'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _isEmpty2.default;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/isEmpty.js
// module id = 1257
// module chunks = 0